'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

const FilterMapClient = dynamic(() => import('./FilterMapClient').then((m) => m.default), {
  ssr: false,
  loading: () => null,
})

const FilterMap: FC = () => <FilterMapClient />

export default FilterMap
